import React from 'react';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { dataGridSx } from '../../common/styled/DataGrid';
import pallet from '../../../layouts/pallet';
import { AttendanceReportProps } from '../types/AttendanceReportType';
import tableColumnUtils from '../../../utils/tableColumnUtils';
import { PageWrapper } from '../../common/styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';

const AttendanceReportTable = ({
  attendanceReportTableData
}: {
  attendanceReportTableData: AttendanceReportProps[];
}) => {
  const uniqueKeys = tableColumnUtils.extractUniqueKeys(
    attendanceReportTableData
  );
  const dynamicColumns: GridColDef[] =
    tableColumnUtils.createColumnsFromKeys(uniqueKeys);
  return (
    <PageWrapper>
      <DataGrid
        rowHeight={50}
        rows={attendanceReportTableData}
        columns={dynamicColumns}
        columnVisibilityModel={{
          id: false
        }}
        disableRowSelectionOnClick
        pageSizeOptions={tableColumnUtils.PAGE_SIZE_OPTIONS}
        initialState={tableColumnUtils.DATA_GRID_INITIAL_STATE}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{
          toolbar: {
            printOptions: { disableToolbarButton: true },
            showQuickFilter: true
          }
        }}
        sx={{
          ...dataGridSx(pallet),
          '& .MuiDataGrid-virtualScroller': {
            overflowY: 'auto'
          }
        }}
      />
    </PageWrapper>
  );
};

export default AttendanceReportTable;
